var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('logged-in-layout',[_c('main',[_c('h1',[_vm._v("Contacts")]),_vm._v(" "),_c('SearchContacts',{attrs:{"features":_vm.features}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fc77900","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contacts/Contacts.vue
// module id = 0eIg
// module chunks = 1